import { render, staticRenderFns } from "./RedeemConfirmation.vue?vue&type=template&id=be95773a&scoped=true&"
import script from "./RedeemConfirmation.vue?vue&type=script&lang=js&"
export * from "./RedeemConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RedeemConfirmation.vue?vue&type=style&index=0&id=be95773a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be95773a",
  null
  
)

export default component.exports